import { FC, useEffect, useState } from 'react';

/// material-ui
import { useTheme } from '@mui/material/styles';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';
import BlockTwoToneIcon from '@mui/icons-material/Download';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import PublicTwoToneIcon from '@mui/icons-material/PublicTwoTone';
import FingerprintTwoToneIcon from '@mui/icons-material/FingerprintTwoTone';
import AccountBalanceTwoToneIcon from '@mui/icons-material/AccountBalanceTwoTone';
import CakeTwoToneIcon from '@mui/icons-material/CakeTwoTone';
import WcTwoToneIcon from '@mui/icons-material/WcTwoTone';
import WorkTwoToneIcon from '@mui/icons-material/WorkTwoTone';

// project imports
import SubCard from 'ui-component/cards/SubCard';
import Chip from 'ui-component/extended/Chip';
import { gridSpacing } from 'store/constant';
import { ThemeMode } from 'config';

// assets
import EmailTwoToneIcon from '@mui/icons-material/EmailTwoTone';
import PhoneAndroidTwoToneIcon from '@mui/icons-material/PhoneAndroidTwoTone';
import MainCard from 'ui-component/cards/MainCard';

import { alpha, Avatar, CircularProgress, Tooltip } from '@mui/material';
import { usePolicyStore } from 'Application/store';
import Loader from 'ui-component/Loader';
import { useParams } from 'react-router-dom';
import { GetSinglePolicyByQuoteNumberResponse } from 'Application/models';
import { addCommasToNumbers, getBackgroundColor } from 'Application/utils';
import dayjs from 'dayjs';
import { toast } from 'sonner';
import BackTo from 'Application/components/NavigateBack';

const detailsIconSX = {
    width: 15,
    height: 15,
    verticalAlign: 'text-top',
    mr: 0.5,
    mt: 0.25
};

function createData(
    nameEmail: string,
    phoneNumber: string,
    nationality: string,
    passportNumber: string,
    kraPin: string,
    dateOfBirth: string,
    gender: string,
    occupation: string,
    attachedDocuments: string
) {
    return {
        nameEmail,
        phoneNumber,
        nationality,
        passportNumber,
        kraPin,
        dateOfBirth,
        gender,
        occupation,
        attachedDocuments
    };
}

interface ViewPolicyProps {
    getSinglePolicyByQuotationNo: GetSinglePolicyByQuoteNumberResponse | null | undefined;
}

const ViewPolicy: FC<ViewPolicyProps> = () => {
    const theme = useTheme();
    const { policyNumber } = useParams(); // Extract policyNumber from the URL
    const [downloading, setDownloading] = useState<string | null>(null);

    const {
        getSinglePolicyByQuotationNo,
        isLoading: isPolicyNoLoading,
        singlepolicyByQuotatioNoDetails
    } = usePolicyStore((state) => ({
        getSinglePolicyByQuotationNo: state.getSinglePolicyByQuotationNo,
        singlepolicyByQuotatioNoDetails: state.singlepolicyByQuotatioNoDetails,
        isLoading: state.isLoading
    }));
    const {
        getDependantsDetails,
        isLoading: isDepedantsDetailsLoading,
        dependantsDetails
    } = usePolicyStore((state) => ({
        getDependantsDetails: state.getDependantsDetails,
        dependantsDetails: state.dependantsDetails,
        isLoading: state.isLoading
    }));

    useEffect(() => {
        console.log('running, .........................');
        if (policyNumber) {
            getSinglePolicyByQuotationNo(policyNumber);
            getDependantsDetails(policyNumber);
        }
    }, [policyNumber]);

    console.log(singlepolicyByQuotatioNoDetails, 'policyByQuotatioNoDetails');
    // Destructure data from singlepolicyByQuotatioNoDetails
    const {
        policyNumber: policyNo,
        issuedBy,
        policyStatus,
        policyTransactionStatus,
        expirationDate,
        createdAt,
        quotation,
        mainCustomer,
        travelPlan,
        agency,
        paymentMethod,
        transactionNumber,
        amount,
        bookedOnEvo,
        coverEdgePolicyCode
    } = singlepolicyByQuotatioNoDetails || {};

    // Destructure the quotation and mainCustomer details for easier use
    const {
        quotationNumber,
        quotationStatus,
        travelDestinations,
        sourceLocation,
        departureDate,
        returnDate,
        createdAt: quoteCreatedAt
    } = quotation || {};

    const {
        phoneNumber,
        emailAddress,
        firstName,
        otherNames,
        gender,
        nationality,
        taxNumber,
        dateOfBirth,
        identificationNumber,
        occupation,
        documents
    } = mainCustomer || {};

    const {
        getPolicyUploadedFiles,
        isError,
        error,
        isLoading: isDownloadFileLoading
    } = usePolicyStore((state) => ({
        getPolicyUploadedFiles: state.getPolicyUploadedFiles,
        isError: state.isError,
        error: state.error,
        isLoading: state.isLoading
    }));

    const handleDownloadFiles = async (fileName: string) => {
        setDownloading(fileName);
        try {
            toast.info('Downloading Attached file...');
            const policyDocumentBlob = await getPolicyUploadedFiles(fileName);

            const url = window.URL.createObjectURL(policyDocumentBlob);
            const a = document.createElement('a');
            a.href = url;
            a.download = `Policy_Attached_${fileName}.pdf`;

            document.body.appendChild(a);
            a.click();
            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);

            toast.success(`${fileName} downloaded successfully`);
        } catch (error) {
            console.error(error);
            toast.error(`Failed to download ${fileName}`);
        } finally {
            setDownloading(null);
        }
    };
    const handleCopyToClipboard = (text: string) => {
        navigator.clipboard.writeText(text);
        toast.success('Email copied to clipboard'); // Optional toast notification for feedback
    };

    if (isPolicyNoLoading && isDepedantsDetailsLoading) {
        return <Loader />;
    }

    const hasMpesaString = paymentMethod?.includes('M-PESA') || paymentMethod?.includes('M-pesa');

    console.log('This is the main customer occupation: ', mainCustomer?.occupation);

    // dependantsDetails!.map((dependant) => {
    //     console.log('This is the dependant occupation: ', dependant.occupation)
    // });

    console.log(dependantsDetails);

    return (
        <>
            <BackTo title={'Back To Policies'} />

            <MainCard>
                <Grid container spacing={gridSpacing}>
                    <Grid item xs={12}>
                        <SubCard
                            title="Completed Transaction Details"
                            secondary={
                                <Typography variant="subtitle1">Placed on {dayjs(createdAt || 'N/A').format('YYYY-MM-DD')}</Typography>
                            }
                        >
                            <Grid container spacing={gridSpacing}>
                                <Grid item xs={12}>
                                    <Typography variant="h4" className="mb-4">
                                        Main Customer
                                    </Typography>
                                    <Grid container spacing={2}>
                                        {/* Avatar and Name */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Stack direction="row" alignItems="center" spacing={2}>
                                                <Avatar className="bg-primary text-[1rem]">
                                                    {firstName?.charAt(0)}
                                                    {otherNames?.charAt(0)}
                                                </Avatar>
                                                <Typography variant="body1">
                                                    {firstName} {otherNames}
                                                </Typography>
                                            </Stack>
                                        </Grid>

                                        {/* Phone Number */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Typography variant="body2" display="flex" alignItems="center">
                                                <PhoneAndroidTwoToneIcon sx={{ mr: 1 }} /> {phoneNumber}
                                            </Typography>
                                        </Grid>

                                        {/* Email Address */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Typography variant="body2" display="flex" alignItems="center">
                                                <EmailTwoToneIcon sx={{ mr: 1 }} /> {emailAddress}
                                                <Tooltip title="Copy email">
                                                    <IconButton
                                                        onClick={() => handleCopyToClipboard(emailAddress ?? '')}
                                                        size="small"
                                                        sx={{ ml: 1 }}
                                                    >
                                                        <ContentCopyIcon fontSize="small" />
                                                    </IconButton>
                                                </Tooltip>
                                            </Typography>
                                        </Grid>

                                        {/* Nationality */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Typography variant="body2" display="flex" alignItems="center">
                                                <PublicTwoToneIcon sx={{ mr: 1 }} /> {nationality}
                                            </Typography>
                                        </Grid>

                                        {/* Identification Number */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Typography variant="body2" display="flex" alignItems="center">
                                                <FingerprintTwoToneIcon sx={{ mr: 1 }} /> {identificationNumber}
                                            </Typography>
                                        </Grid>

                                        {/* Date Of Birth */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Typography variant="body2" display="flex" alignItems="center">
                                                <CakeTwoToneIcon sx={{ mr: 1 }} /> {dateOfBirth}
                                            </Typography>
                                        </Grid>

                                        {/* Gender */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Typography variant="body2" display="flex" alignItems="center">
                                                <WcTwoToneIcon sx={{ mr: 1 }} /> {gender}
                                            </Typography>
                                        </Grid>

                                        {/* Occupation */}
                                        <Grid item xs={12} sm={6} md={3}>
                                            <Typography variant="body2" display="flex" alignItems="center">
                                                <WorkTwoToneIcon sx={{ mr: 1 }} /> {occupation?.description.toTitle()}
                                            </Typography>
                                        </Grid>

                                        {/* Documents */}
                                        <Grid item xs={12}>
                                            <Typography variant="subtitle1" gutterBottom>
                                                Documents
                                            </Typography>
                                            {mainCustomer && mainCustomer.documents?.length > 0 ? (
                                                <Stack direction="row" spacing={2} flexWrap="wrap">
                                                    {mainCustomer.documents.map((doc, index) => (
                                                        <Tooltip key={index} placement="top" title={`Download ${doc.documentType}`}>
                                                            <IconButton
                                                                color="primary"
                                                                onClick={() => handleDownloadFiles(doc.documentName)}
                                                                disabled={isDownloadFileLoading && downloading === doc.documentName}
                                                                size="large"
                                                                sx={{
                                                                    color:
                                                                        isDownloadFileLoading && downloading === doc.documentName
                                                                            ? 'grey.400'
                                                                            : 'orange.dark',
                                                                    borderColor: 'orange.main',
                                                                    '&:hover': {
                                                                        bgcolor: isDownloadFileLoading ? 'inherit' : 'orange.light'
                                                                    }
                                                                }}
                                                            >
                                                                {isDownloadFileLoading && downloading === doc.documentName ? (
                                                                    <CircularProgress size={24} color="inherit" />
                                                                ) : (
                                                                    <BlockTwoToneIcon sx={{ fontSize: '1.1rem', ml: 1 }} />
                                                                )}
                                                            </IconButton>
                                                        </Tooltip>
                                                    ))}
                                                </Stack>
                                            ) : (
                                                <Typography variant="body2">No documents available</Typography>
                                            )}
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>
                                <Grid item xs={12}>
                                    <Grid container spacing={3}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Stack spacing={2}>
                                                <Typography variant="h4">Policy Details</Typography>
                                                <Stack spacing={0.5}>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Policy No:</Typography>
                                                        <Typography variant="body2">{policyNo}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Aims Status:</Typography>
                                                        <Chip
                                                            label={policyTransactionStatus}
                                                            size="small"
                                                            sx={
                                                                policyTransactionStatus === 'DEBITED'
                                                                    ? {
                                                                          bgcolor:
                                                                              theme.palette.mode === ThemeMode.DARK
                                                                                  ? 'dark.main'
                                                                                  : alpha(theme.palette.success.light, 0.6),
                                                                          color: 'success.dark'
                                                                      }
                                                                    : {
                                                                          bgcolor:
                                                                              theme.palette.mode === ThemeMode.DARK
                                                                                  ? 'dark.main'
                                                                                  : alpha(theme.palette.primary.light, 0.6),
                                                                          color: 'primary.dark'
                                                                      }
                                                            }
                                                        />
                                                    </Stack>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">EVO Booking Status:</Typography>
                                                        <Chip
                                                            label={bookedOnEvo ? 'BOOKED' : 'NOT BOOKED'}
                                                            size="small"
                                                            sx={
                                                                bookedOnEvo
                                                                    ? {
                                                                          bgcolor:
                                                                              theme.palette.mode === ThemeMode.DARK
                                                                                  ? 'dark.main'
                                                                                  : alpha(theme.palette.success.light, 0.6),
                                                                          color: 'success.dark'
                                                                      }
                                                                    : {
                                                                          bgcolor:
                                                                              theme.palette.mode === ThemeMode.DARK
                                                                                  ? 'dark.main'
                                                                                  : alpha(theme.palette.primary.light, 0.6),
                                                                          color: 'primary.dark'
                                                                      }
                                                            }
                                                        />
                                                    </Stack>
                                                    {coverEdgePolicyCode && (
                                                        <Stack direction="row" spacing={1}>
                                                            <Typography variant="subtitle1">Cover edge policy code:</Typography>
                                                            <Typography variant="body2">{coverEdgePolicyCode}</Typography>
                                                        </Stack>
                                                    )}
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Created At:</Typography>
                                                        <Typography variant="body2">{dayjs(createdAt).format('YYYY-MM-DD')}</Typography>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Stack spacing={2}>
                                                <Typography variant="h4">Agency Details</Typography>
                                                <Stack spacing={0}>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Agency Name:</Typography>
                                                        <Typography variant="body2">{agency?.name}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Issued By:</Typography>
                                                        <Typography variant="body2">{issuedBy}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Expiry Date:</Typography>
                                                        <Typography variant="body2">
                                                            {dayjs(expirationDate).format('YYYY-MM-DD')}
                                                        </Typography>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Stack spacing={2}>
                                                <Typography variant="h4">Travel Plan</Typography>
                                                <Stack spacing={0}>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Travel Plan:</Typography>
                                                        <Typography variant="body2">{travelPlan?.name}</Typography>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid item xs={12}>
                                    <Divider />
                                </Grid>

                                <Grid item xs={12}>
                                    <Typography variant="h4">Quotation Details</Typography>
                                    <Grid container spacing={3} sx={{ mt: '1px' }}>
                                        <Grid item xs={12} sm={6} md={4}>
                                            <Stack spacing={2}>
                                                <Stack spacing={0}>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Quote No:</Typography>
                                                        <Typography variant="body2">{quotationNumber}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Quotation Status:</Typography>
                                                        <Chip
                                                            label={quotationStatus}
                                                            size="small"
                                                            sx={
                                                                quotationStatus === 'COMPLETED'
                                                                    ? {
                                                                          bgcolor:
                                                                              theme.palette.mode === ThemeMode.DARK
                                                                                  ? 'dark.main'
                                                                                  : alpha(theme.palette.success.light, 0.6),
                                                                          color: 'success.dark'
                                                                      }
                                                                    : {
                                                                          bgcolor:
                                                                              theme.palette.mode === ThemeMode.DARK
                                                                                  ? 'dark.main'
                                                                                  : alpha(theme.palette.primary.light, 0.6),
                                                                          color: 'primary.dark'
                                                                      }
                                                            }
                                                        />
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Stack spacing={2}>
                                                <Stack spacing={0}>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Departure Date:</Typography>
                                                        <Typography variant="body2">{departureDate}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Return Date:</Typography>
                                                        <Typography variant="body2">{returnDate}</Typography>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </Grid>

                                        <Grid item xs={12} sm={6} md={4}>
                                            <Stack spacing={2}>
                                                <Stack spacing={0}>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Travel From:</Typography>
                                                        <Typography variant="body2">{sourceLocation}</Typography>
                                                    </Stack>
                                                    <Stack direction="row" spacing={1}>
                                                        <Typography variant="subtitle1">Destinations:</Typography>
                                                        <Typography variant="body2">
                                                            {travelDestinations?.map((destination, index) => (
                                                                <span key={index}>
                                                                    {destination.destinationName}
                                                                    {index < travelDestinations.length - 1 && ', '}
                                                                </span>
                                                            ))}
                                                        </Typography>
                                                    </Stack>
                                                </Stack>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Grid>
                    <Grid item xs={12}>
                        <SubCard title="Other Customers' Details" content={false}>
                            <Grid container spacing={3}>
                                <Grid item xs={12}>
                                    <TableContainer>
                                        <Table>
                                            <TableHead>
                                                <TableRow>
                                                    <TableCell sx={{ pl: 3 }}>Name</TableCell>
                                                    {/* <TableCell align="right">Phone Number</TableCell> */}
                                                    {/* <TableCell align="left">Nationality</TableCell> */}
                                                    <TableCell align="left">Passport Number</TableCell>
                                                    {/* <TableCell align="right">Kra Pin</TableCell> */}
                                                    <TableCell align="left">Date Of Birth</TableCell>
                                                    {/* <TableCell align="right">Occupation</TableCell> */}
                                                    <TableCell align="center">Attached Documents</TableCell>
                                                    {/* <TableCell align="left" sx={{ pr: 3 }} /> */}
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {/* Render main customer details */}
                                                {/* {mainCustomer ? (
                                                    <TableRow>
                                                        <TableCell sx={{ pl: 3 }}>
                                                            <Stack direction="row" alignItems="center" spacing={2}>
                                                                <Avatar
                                                                    alt="User Avatar"
                                                                    className={`border border-gray-200 ${
                                                                        mainCustomer.firstName
                                                                            ? getBackgroundColor(mainCustomer.firstName[0].toUpperCase())
                                                                            : 'transparent'
                                                                    }`}
                                                                >
                                                                    {mainCustomer.firstName ? mainCustomer.firstName[0].toUpperCase() : ''}
                                                                </Avatar>
                                                                <Stack>
                                                                    <Typography variant="subtitle1">
                                                                        {mainCustomer.firstName || ''} {mainCustomer.otherNames || ''}
                                                                    </Typography>
                                                                    <Typography variant="subtitle2" noWrap>
                                                                        {mainCustomer.emailAddress || ''}
                                                                    </Typography>
                                                                </Stack>
                                                            </Stack>
                                                        </TableCell>
                                                        {/* <TableCell align="right">{mainCustomer.phoneNumber}</TableCell> *}
                                                        <TableCell align="right">{mainCustomer.nationality}</TableCell>
                                                        <TableCell align="right">{mainCustomer.identificationNumber}</TableCell>
                                                        {/* <TableCell align="right">{mainCustomer.taxNumber}</TableCell> *}
                                                        <TableCell align="right">
                                                            {dayjs(mainCustomer.dateOfBirth).format('YYYY-MM-DD')}{' '}
                                                            <Chip
                                                                label={dayjs().diff(dayjs(mainCustomer.dateOfBirth), 'year')}
                                                                color="primary"
                                                                size="small"
                                                                sx={{ marginLeft: 1 }}
                                                            />
                                                        </TableCell>
                                                        <TableCell align="right">{mainCustomer.gender}</TableCell>
                                                        <TableCell align="right">{mainCustomer.occupation?.description || '---'}</TableCell>
                                                        <TableCell align="right">
                                                            {mainCustomer.documents?.length > 0 ? (
                                                                mainCustomer.documents.map((doc, index) => (
                                                                    <Tooltip
                                                                        key={index}
                                                                        placement="top"
                                                                        title={`Download ${doc.documentType}`}
                                                                    >
                                                                        <IconButton
                                                                            color="primary"
                                                                            onClick={() => handleDownloadFiles(doc.documentName)}
                                                                            disabled={
                                                                                isDownloadFileLoading && downloading === doc.documentName
                                                                            }
                                                                            size="large"
                                                                            sx={{
                                                                                color:
                                                                                    isDownloadFileLoading &&
                                                                                    downloading === doc.documentName
                                                                                        ? 'grey.400'
                                                                                        : 'orange.dark',
                                                                                borderColor: 'orange.main',
                                                                                '&:hover': {
                                                                                    bgcolor: isDownloadFileLoading
                                                                                        ? 'inherit'
                                                                                        : 'orange.light'
                                                                                }
                                                                            }}
                                                                        >
                                                                            {isDownloadFileLoading && downloading === doc.documentName ? (
                                                                                <CircularProgress size={24} color="inherit" />
                                                                            ) : (
                                                                                <BlockTwoToneIcon sx={{ fontSize: '1.1rem', ml: 1 }} />
                                                                            )}
                                                                        </IconButton>
                                                                    </Tooltip>
                                                                ))
                                                            ) : (
                                                                <Typography variant="body2">No documents</Typography>
                                                            )}
                                                        </TableCell>
                                                    </TableRow>
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={10} align="center">
                                                            No customer data available
                                                        </TableCell>
                                                    </TableRow>
                                                )} */}

                                                {/* Render dependants details */}
                                                {dependantsDetails && dependantsDetails.length > 0 ? (
                                                    dependantsDetails.map((dependant, index) => {
                                                        const dependantFirstName = dependant.fullName.split(' ')[0];

                                                        return (
                                                            <TableRow key={index}>
                                                                <TableCell sx={{ pl: 3 }}>
                                                                    <Stack direction="row" alignItems="center" spacing={2}>
                                                                        <Avatar
                                                                            alt="Dependant Avatar"
                                                                            className={`border border-gray-200 ${
                                                                                getBackgroundColor(dependantFirstName[0].toUpperCase()) ??
                                                                                'transparent'
                                                                            }`}
                                                                        >
                                                                            {dependantFirstName[0].toUpperCase() ?? ''}
                                                                        </Avatar>
                                                                        <Typography variant="subtitle1">
                                                                            {dependant.fullName.toTitle()}
                                                                        </Typography>
                                                                    </Stack>
                                                                </TableCell>
                                                                {/* <TableCell align="right">{dependant.phoneNumber}</TableCell> */}
                                                                {/* <TableCell align="left">{dependant.nationality}</TableCell> */}
                                                                <TableCell align="left">{dependant.passportNumber}</TableCell>
                                                                {/* <TableCell align="right">{dependant.taxNumber}</TableCell> */}
                                                                <TableCell align="left">
                                                                    {dayjs(dependant.dateOfBirth).format('YYYY-MM-DD')}{' '}
                                                                    <Chip
                                                                        label={dayjs().diff(dayjs(dependant.dateOfBirth), 'year')}
                                                                        color="primary"
                                                                        size="small"
                                                                        sx={{ marginLeft: 1 }}
                                                                    />
                                                                </TableCell>
                                                                {/* <TableCell align="right">
                                                                {'----'}
                                                            </TableCell> */}
                                                                <TableCell align="center">
                                                                    {dependant.document ? (
                                                                        <Tooltip
                                                                            placement="top"
                                                                            title={`Download ${dependant.document.documentType}`}
                                                                        >
                                                                            <IconButton
                                                                                color="primary"
                                                                                onClick={() =>
                                                                                    handleDownloadFiles(dependant.document.documentName)
                                                                                }
                                                                                disabled={
                                                                                    isDownloadFileLoading &&
                                                                                    downloading === dependant.document.documentName
                                                                                }
                                                                                size="large"
                                                                                sx={{
                                                                                    color:
                                                                                        isDownloadFileLoading &&
                                                                                        downloading === dependant.document.documentName
                                                                                            ? 'grey.400'
                                                                                            : 'orange.dark',
                                                                                    borderColor: 'orange.main',
                                                                                    '&:hover': {
                                                                                        bgcolor: isDownloadFileLoading
                                                                                            ? 'inherit'
                                                                                            : 'orange.light'
                                                                                    }
                                                                                }}
                                                                            >
                                                                                {isDownloadFileLoading &&
                                                                                downloading === dependant.document.documentName ? (
                                                                                    <CircularProgress size={24} color="inherit" />
                                                                                ) : (
                                                                                    <BlockTwoToneIcon sx={{ fontSize: '1.1rem', ml: 1 }} />
                                                                                )}
                                                                            </IconButton>
                                                                        </Tooltip>
                                                                    ) : (
                                                                        <Typography variant="body2">No documents</Typography>
                                                                    )}
                                                                </TableCell>
                                                            </TableRow>
                                                        );
                                                    })
                                                ) : (
                                                    <TableRow>
                                                        <TableCell colSpan={10} align="center">
                                                            No dependants
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>

                                <Grid item xs={12}>
                                    <SubCard
                                        sx={{
                                            mx: 3,
                                            mb: 3,
                                            bgcolor: theme.palette.mode === ThemeMode.DARK ? 'dark.main' : 'primary.light'
                                        }}
                                    >
                                        <Grid container justifyContent="flex-end" spacing={gridSpacing}>
                                            <Grid item sm={6} md={4}>
                                                <Grid container spacing={2}>
                                                    <Grid item xs={12}>
                                                        <Divider sx={{ bgcolor: 'dark.main' }} />
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Grid container spacing={1}>
                                                            <Grid item xs={6}>
                                                                <Typography align="right" color="primary" variant="subtitle1">
                                                                    Total Amount Paid:
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Typography align="right" color="primary" variant="subtitle1">
                                                                    Ksh {addCommasToNumbers(amount?.toString() ?? '')}
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Typography align="right" color="primary" variant="subtitle1">
                                                                    Payment Method:
                                                                </Typography>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                <Typography align="right" color="primary" variant="subtitle1">
                                                                    {paymentMethod}
                                                                </Typography>
                                                            </Grid>
                                                            {hasMpesaString && (
                                                                <>
                                                                    <Grid item xs={6}>
                                                                        <Typography align="right" color="primary" variant="subtitle1">
                                                                            Transaction number:
                                                                        </Typography>
                                                                    </Grid>
                                                                    <Grid item xs={6}>
                                                                        <Typography align="right" color="primary" variant="subtitle1">
                                                                            {transactionNumber}
                                                                        </Typography>
                                                                    </Grid>
                                                                </>
                                                            )}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </SubCard>
                                </Grid>
                            </Grid>
                        </SubCard>
                    </Grid>
                </Grid>
            </MainCard>
        </>
    );
};

export default ViewPolicy;
